export default "__VITE_ASSET__23878388__"